import { getAmplitudeInstance } from '../amplitudeHelpers';
import DistanceAwaySliderActionTaken from '../enums/DistanceAwaySliderActionTaken';

type logExploreMapDistanceAwaySliderClickedParams = {
  action_taken: DistanceAwaySliderActionTaken;
  from_search_location: boolean;
  searched_location: string;
};

/**
 * User interacts with the 'distance away' slider on explore map on web. Should fire once per potential action per session.
 * @param params - Attributes to log with the amplitude event
 * @param params.action_taken - Action taken when user interactions with the 'distance away' slider on explore map on web.
 * @param params.from_search_location - TRUE if the distance away slider is clicked from a searched location, FALSE if it's the user's current location
 * @param params.searched_location - Location name's string if the distance away slider is clicked from a searched location
 */
const logExploreMapDistanceAwaySliderClicked = (
  { action_taken, from_search_location, searched_location }: logExploreMapDistanceAwaySliderClickedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'explore map distance away slider clicked',
    { 'action taken': action_taken, 'from search location': from_search_location, 'searched location': searched_location },
    callback
  );
};

export default logExploreMapDistanceAwaySliderClicked;
